module.exports = __webpack_public_path__ + "static/media/list-view.5950d4bf.svg";